/* eslint-disable react/no-unstable-nested-components */
import { Input, Rate } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  setRating,
  setTextareaValue,
  feedbackState,
} from '../store/stateSlice';
// import { injectReducer } from '../../../../app';
// import reducer from '../store';

const { TextArea } = Input;

// injectReducer('feedback', reducer);

function DrawerContent() {
  const { t } = useTranslation();
  const [hoverValue, setHoverValue] = useState(0);

  const dispatch = useDispatch();
  const { rating, textareaValue } = useSelector(feedbackState);

  const handleChange = (newValue: number) => {
    dispatch(setRating(newValue));
  };

  const handleTextareaChange = (newValue: string) => {
    dispatch(setTextareaValue(newValue));
  };

  const handleHoverChange = (newValue: number) => {
    setHoverValue(newValue);
  };

  const getBoxColor = (index: any) => {
    const isSelected = index + 1 === rating;
    const isHovered = index + 1 <= hoverValue;

    if (isSelected) {
      switch (index + 1) {
        case 1:
          return '#FF1A39';
        case 2:
          return '#FF7B22';
        case 3:
          return '#FFB22A';
        case 4:
          return '#00CE5F';
        case 5:
          return '#009B4B';
        default:
          return '#ccc';
      }
    } else if (isHovered) {
      return '#ccc';
    } else return 'white';
  };
  const getNumberColor = (index: any) => {
    const isSelected = index + 1 === rating;
    if (isSelected) {
      return 'white';
    }
    return 'black';
  };
  const getBorder = (index: any) => {
    const isSelected = index + 1 === rating;
    if (isSelected) {
      return '1px solid #D0D0D0';
    }
    return 'none';
  };
  return (
    <div>
      <div>
        <div className="mb-8 flex justify-evenly border border-1 border-solid border-[#D0D0D0] p-2">
          <div className="mr-2 mt-1 w-[50px]">{t('feedback.unhappy')}</div>
          <Rate
            className="mt-2"
            value={rating}
            onChange={handleChange}
            onHoverChange={handleHoverChange}
            character={({ index }) => (
              <span
                style={{
                  backgroundColor: getBoxColor(index),
                  display: 'inline-block',
                  width: '25px',
                  height: '25px',
                  textAlign: 'center',
                  lineHeight: '26px',
                  border: getBorder(index),
                  borderRadius: '5px',
                  cursor: 'pointer',
                  color: getNumberColor(index),
                  fontSize: '15px',
                }}
              >
                <span>{index !== undefined ? index + 1 : null}</span>
              </span>
            )}
          />
          <div className="ml-2 mt-1 w-[50px]">{t('feedback.satisfied')}</div>
        </div>

        <div className="mb-4 text-[15px] text-[#212121]">
          {t('feedback.textarea')}
        </div>
        <div>
          <TextArea
            required
            value={textareaValue}
            showCount
            maxLength={500}
            onChange={(e) => handleTextareaChange(e.target.value)}
          />
          {/* {!textareaValue && (
            <span className="text-red-900 text-[10px]">
              *This field is required
            </span>
          )} */}
        </div>
      </div>
    </div>
  );
}

export default DrawerContent;
